import Heatmap from './heatmap';
angular.module('zc.projects.heatmap')
  .component('zcHeatmap', {
    templateUrl: '/templates/projects.heatmap/heatmap.html',
    bindings: {
      project: '<'
    },
    controller: zcHeatmapController
  });

zcHeatmapController.$inject = ['$element', '$stateParams', 'Services'];
function zcHeatmapController($element, $stateParams, Services) {
  const vm = this;
  const heatmap = null; // eslint-disable-line
  const heatmapUrls = {
    1: 'http://www.mtgec.jp/shop/default.aspx'
  };

  vm.$onInit = () => {
    // TODO: HACK! figure out how to properly encode url
    vm.url = heatmapUrls[$stateParams.url];
    vm.showLayers = {
      clicks: true,
      mouseMovement: true,
      outsideBoundaries: false,
      insights: true,
    };

    vm.insights = [
      {
        x: 215,
        y: 259,
        message: 'バナーが注目されない為、画像変更、または削除をお勧めいたします。'
      },
      {
        x: 615,
        y: 1159,
        message: '隣のボタンがよりクリックが少ない為、文言変更をお勧めいたします。'
      },
      {
        x: 74,
        y: 2251,
        message: '注目度が高い為、上に上げることをお勧めいたします。'
      },
      {
        x: 400,
        y: 4250,
        message: '注目度が高い為、上に上げることをお勧めいたします。'
      },
      {
        x: 89,
        y: 4421,
        message: '注目度が高い為、上に上げることをお勧めいたします。'
      },
      {
        x: 400,
        y: 6150,
        message: '注目度が高い為、上に上げることをお勧めいたします。'
      },
    ];

    vm.filters = {
      convertedUsers: false,
      newUsers: false,
    };

    vm.redraw = redraw;

    initializeHeatmap(vm.url);
  };

  function initializeHeatmap(url) {
    const element = $element.find('.svg-container-main')[0];
    vm.heatmap = new Heatmap(element, Services, vm.showLayers, vm.filters);
  }

  function redraw() {
    vm.heatmap.redraw();
  }

}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.heatmap/heatmap.component.js